// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Documentation Styles */
:root {
  --primary-color: #FF8C00;
  --primary-hover: #FFA500;
  --text-dark: #1a1a1a;
  --text-light: #666;
  --text-lighter: #999;
  --bg-light: #f8f9fa;
  --bg-white: #ffffff;
  --bg-dark: #2d3748;
  --border-color: #e9ecef;
  --border-light: #dee2e6;
  --sidebar-width: 280px;
  --header-height: 70px;
  --container-max-width: 1200px;
}

/* Reset and Base */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.6;
  color: var(--text-dark);
  background-color: var(--bg-white);
}

/* Layout */
.docs-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.docs-container {
  max-width: var(--container-max-width);
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

/* Header */
.docs-header {
  background: var(--bg-white);
  border-bottom: 1px solid var(--border-color);
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.docs-header-content {
  height: var(--header-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.docs-logo .logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--text-dark);
}

.logo-music {
  color: var(--primary-color);
  margin-right: 8px;
}

.logo-text {
  color: var(--text-dark);
}

.docs-nav {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-link {
  text-decoration: none;
  color: var(--text-dark);
  font-weight: 500;
  transition: color 0.2s;
  padding: 0.5rem 0;
}

.nav-link:hover,
.nav-link.active {
  color: var(--primary-color);
}

/* Search */
.search-container {
  position: relative;
  display: flex;
  align-items: center;
}

.search {
  position: relative;
  width: 300px;
}

.search-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input {
  width: 100%;
  padding: 0.5rem 2.5rem 0.5rem 1rem;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-size: 0.875rem;
  transition: border-color 0.2s, box-shadow 0.2s;
  background: var(--bg-white);
}

.search-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(255, 140, 0, 0.1);
}

.search-icon {
  position: absolute;
  right: 10px;
  display: flex;
  align-items: center;
  color: var(--text-lighter);
}

.search-spinner {
  animation: spin 1s linear infinite;
}

.search-spinner-small {
  animation: spin 1s linear infinite;
  font-size: 0.875rem;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Search Results Dropdown */
.search-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--bg-white);
  border: 1px solid var(--border-color);
  border-top: none;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  max-height: 400px;
  overflow-y: auto;
  z-index: 1000;
}

.search-loading {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  color: var(--text-light);
}

.search-results-list {
  max-height: 400px;
  overflow-y: auto;
}

.search-result-item {
  display: block;
  width: 100%;
  padding: 0.75rem 1rem;
  text-align: left;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid var(--border-light);
}

.search-result-item:hover {
  background-color: var(--bg-light);
}

.search-result-item:last-child {
  border-bottom: none;
}

.search-result-title {
  font-weight: 600;
  margin-bottom: 0.25rem;
  color: var(--text-dark);
}

.search-result-path {
  font-size: 0.75rem;
  color: var(--text-lighter);
  margin-bottom: 0.5rem;
}

.search-result-description {
  font-size: 0.875rem;
  color: var(--text-light);
  line-height: 1.4;
}

.search-highlight {
  background: rgba(255, 140, 0, 0.2);
  color: var(--primary-color);
  font-weight: 500;
}

.search-no-results {
  padding: 2rem 1rem;
  text-align: center;
  color: var(--text-light);
}

.search-no-results-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  opacity: 0.5;
}

.search-no-results-text {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: var(--text-dark);
}

.search-no-results-hint {
  font-size: 0.875rem;
  color: var(--text-light);
}


/* Breadcrumb */
.breadcrumb {
  background: var(--bg-light);
  border-bottom: 1px solid var(--border-color);
  padding: 0.75rem 0;
}

.breadcrumb-list {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  list-style: none;
}

.breadcrumb-item:not(:last-child)::after {
  content: '/';
  margin-left: 0.5rem;
  color: var(--text-lighter);
}

.breadcrumb-link {
  color: var(--text-light);
  text-decoration: none;
  transition: color 0.2s;
}

.breadcrumb-link:hover {
  color: var(--primary-color);
}

.breadcrumb-current {
  color: var(--text-dark);
  font-weight: 500;
}

/* Main Content */
.docs-main {
  flex: 1;
  padding: 2rem 0;
}

.docs-content-wrapper {
  display: flex;
  gap: 3rem;
}

/* Sidebar */
.docs-sidebar {
  width: var(--sidebar-width);
  flex-shrink: 0;
  position: sticky;
  top: calc(var(--header-height) + 1rem);
  height: fit-content;
  max-height: calc(100vh - var(--header-height) - 2rem);
  overflow-y: auto;
}

.sidebar-section {
  margin-bottom: 2rem;
}

.sidebar-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-light);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.75rem;
}

.sidebar-list {
  list-style: none;
}

.sidebar-list li {
  margin-bottom: 0.25rem;
}

.sidebar-link {
  display: block;
  padding: 0.375rem 0.75rem;
  color: var(--text-dark);
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.2s;
  font-size: 0.875rem;
}

.sidebar-link:hover {
  background-color: var(--bg-light);
  color: var(--primary-color);
  transform: translateX(2px);
}

.sidebar-link.active {
  background-color: var(--primary-color);
  color: white;
}

/* Content Area */
.docs-content {
  flex: 1;
  min-width: 0;
}

.docs-article {
  max-width: 800px;
  margin-bottom: 3rem;
}

/* Typography */
.docs-article h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: var(--text-dark);
  line-height: 1.2;
}

.docs-article h2 {
  font-size: 1.875rem;
  font-weight: 600;
  margin: 2.5rem 0 1rem;
  color: var(--text-dark);
  border-bottom: 2px solid var(--border-color);
  padding-bottom: 0.5rem;
}

.docs-article h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 2rem 0 1rem;
  color: var(--text-dark);
}

.docs-article h4 {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 1.5rem 0 0.75rem;
  color: var(--text-dark);
}

.docs-article p {
  margin-bottom: 1rem;
  color: var(--text-dark);
  line-height: 1.7;
}

.docs-article ul,
.docs-article ol {
  margin-bottom: 1rem;
  padding-left: 2rem;
}

.docs-article li {
  margin-bottom: 0.5rem;
  color: var(--text-dark);
}

/* Code Blocks */
.docs-article code {
  background: var(--bg-light);
  padding: 0.2rem 0.4rem;
  border-radius: 3px;
  font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
  font-size: 0.875em;
  color: var(--primary-color);
}

.docs-article pre {
  background: var(--bg-dark);
  color: #e2e8f0;
  padding: 1.5rem;
  border-radius: 8px;
  overflow-x: auto;
  margin: 1.5rem 0;
  font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
  font-size: 0.875rem;
  line-height: 1.5;
}

.docs-article pre code {
  background: none;
  padding: 0;
  color: inherit;
  font-size: inherit;
}

/* Blockquotes */
.docs-article blockquote {
  border-left: 4px solid var(--primary-color);
  padding-left: 1.5rem;
  margin: 1.5rem 0;
  font-style: italic;
  color: var(--text-light);
}

/* Tables */
.docs-article table {
  width: 100%;
  border-collapse: collapse;
  margin: 1.5rem 0;
  font-size: 0.875rem;
}

.docs-article th,
.docs-article td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
}

.docs-article th {
  background: var(--bg-light);
  font-weight: 600;
  color: var(--text-dark);
}

.docs-article tr:hover {
  background: var(--bg-light);
}

/* Links */
.docs-article a {
  color: var(--primary-color);
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s;
}

.docs-article a:hover {
  border-bottom-color: var(--primary-color);
}

/* Page Footer */
.docs-page-footer {
  padding-top: 2rem;
  border-top: 1px solid var(--border-color);
}

.docs-footer-nav {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.docs-contribute {
  text-align: center;
  padding: 1rem;
  background: var(--bg-light);
  border-radius: 6px;
}

.edit-link {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
}

.edit-link:hover {
  text-decoration: underline;
}

/* Site Footer */
.docs-footer {
  background: var(--bg-dark);
  color: white;
  padding: 3rem 0 1.5rem;
  margin-top: 3rem;
}

.docs-footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.footer-section h4 {
  margin-bottom: 1rem;
  color: white;
}

.footer-section p {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 1rem;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.2s;
}

.footer-links a:hover {
  color: var(--primary-color);
}

.docs-footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1.5rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .docs-content-wrapper {
    flex-direction: column;
  }

  .docs-sidebar {
    width: 100%;
    position: static;
    max-height: none;
    margin-bottom: 2rem;
  }

  .search-input {
    width: 200px;
  }
}

@media (max-width: 768px) {
  .docs-header-content {
    flex-direction: column;
    height: auto;
    padding: 1rem 0;
    gap: 1rem;
  }

  .docs-nav {
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
  }

  .search-input {
    width: 100%;
  }

  .docs-article h1 {
    font-size: 2rem;
  }

  .docs-article h2 {
    font-size: 1.5rem;
  }

  .docs-footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }
}

/* Print Styles */
@media print {
  .docs-header,
  .docs-sidebar,
  .docs-page-footer,
  .docs-footer {
    display: none;
  }

  .docs-content {
    max-width: none;
    margin: 0;
    padding: 0;
  }

  .docs-article a {
    color: inherit;
    text-decoration: underline;
  }
}`, "",{"version":3,"sources":["webpack://./src/docs/styles/docs.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uGAAuG;EACvG,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA,WAAW;AACX;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,qCAAqC;EACrC,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;;AAGA,eAAe;AACf;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,kGAAkG;EAClG,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kGAAkG;EAClG,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;AACF;;AAEA,iBAAiB;AACjB;EACE;;;;IAIE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;AACF","sourcesContent":["/* Documentation Styles */\n:root {\n  --primary-color: #FF8C00;\n  --primary-hover: #FFA500;\n  --text-dark: #1a1a1a;\n  --text-light: #666;\n  --text-lighter: #999;\n  --bg-light: #f8f9fa;\n  --bg-white: #ffffff;\n  --bg-dark: #2d3748;\n  --border-color: #e9ecef;\n  --border-light: #dee2e6;\n  --sidebar-width: 280px;\n  --header-height: 70px;\n  --container-max-width: 1200px;\n}\n\n/* Reset and Base */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  line-height: 1.6;\n  color: var(--text-dark);\n  background-color: var(--bg-white);\n}\n\n/* Layout */\n.docs-layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.docs-container {\n  max-width: var(--container-max-width);\n  margin: 0 auto;\n  padding: 0 20px;\n  width: 100%;\n}\n\n/* Header */\n.docs-header {\n  background: var(--bg-white);\n  border-bottom: 1px solid var(--border-color);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n}\n\n.docs-header-content {\n  height: var(--header-height);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.docs-logo .logo-link {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: var(--text-dark);\n}\n\n.logo-music {\n  color: var(--primary-color);\n  margin-right: 8px;\n}\n\n.logo-text {\n  color: var(--text-dark);\n}\n\n.docs-nav {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.nav-link {\n  text-decoration: none;\n  color: var(--text-dark);\n  font-weight: 500;\n  transition: color 0.2s;\n  padding: 0.5rem 0;\n}\n\n.nav-link:hover,\n.nav-link.active {\n  color: var(--primary-color);\n}\n\n/* Search */\n.search-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search {\n  position: relative;\n  width: 300px;\n}\n\n.search-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-input {\n  width: 100%;\n  padding: 0.5rem 2.5rem 0.5rem 1rem;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  font-size: 0.875rem;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  background: var(--bg-white);\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(255, 140, 0, 0.1);\n}\n\n.search-icon {\n  position: absolute;\n  right: 10px;\n  display: flex;\n  align-items: center;\n  color: var(--text-lighter);\n}\n\n.search-spinner {\n  animation: spin 1s linear infinite;\n}\n\n.search-spinner-small {\n  animation: spin 1s linear infinite;\n  font-size: 0.875rem;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Search Results Dropdown */\n.search-results {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--bg-white);\n  border: 1px solid var(--border-color);\n  border-top: none;\n  border-radius: 0 0 6px 6px;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n  max-height: 400px;\n  overflow-y: auto;\n  z-index: 1000;\n}\n\n.search-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1rem;\n  color: var(--text-light);\n}\n\n.search-results-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.search-result-item {\n  display: block;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  text-align: left;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.search-result-item:hover {\n  background-color: var(--bg-light);\n}\n\n.search-result-item:last-child {\n  border-bottom: none;\n}\n\n.search-result-title {\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n  color: var(--text-dark);\n}\n\n.search-result-path {\n  font-size: 0.75rem;\n  color: var(--text-lighter);\n  margin-bottom: 0.5rem;\n}\n\n.search-result-description {\n  font-size: 0.875rem;\n  color: var(--text-light);\n  line-height: 1.4;\n}\n\n.search-highlight {\n  background: rgba(255, 140, 0, 0.2);\n  color: var(--primary-color);\n  font-weight: 500;\n}\n\n.search-no-results {\n  padding: 2rem 1rem;\n  text-align: center;\n  color: var(--text-light);\n}\n\n.search-no-results-icon {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n  opacity: 0.5;\n}\n\n.search-no-results-text {\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  color: var(--text-dark);\n}\n\n.search-no-results-hint {\n  font-size: 0.875rem;\n  color: var(--text-light);\n}\n\n\n/* Breadcrumb */\n.breadcrumb {\n  background: var(--bg-light);\n  border-bottom: 1px solid var(--border-color);\n  padding: 0.75rem 0;\n}\n\n.breadcrumb-list {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  list-style: none;\n}\n\n.breadcrumb-item:not(:last-child)::after {\n  content: '/';\n  margin-left: 0.5rem;\n  color: var(--text-lighter);\n}\n\n.breadcrumb-link {\n  color: var(--text-light);\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.breadcrumb-link:hover {\n  color: var(--primary-color);\n}\n\n.breadcrumb-current {\n  color: var(--text-dark);\n  font-weight: 500;\n}\n\n/* Main Content */\n.docs-main {\n  flex: 1;\n  padding: 2rem 0;\n}\n\n.docs-content-wrapper {\n  display: flex;\n  gap: 3rem;\n}\n\n/* Sidebar */\n.docs-sidebar {\n  width: var(--sidebar-width);\n  flex-shrink: 0;\n  position: sticky;\n  top: calc(var(--header-height) + 1rem);\n  height: fit-content;\n  max-height: calc(100vh - var(--header-height) - 2rem);\n  overflow-y: auto;\n}\n\n.sidebar-section {\n  margin-bottom: 2rem;\n}\n\n.sidebar-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-light);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.75rem;\n}\n\n.sidebar-list {\n  list-style: none;\n}\n\n.sidebar-list li {\n  margin-bottom: 0.25rem;\n}\n\n.sidebar-link {\n  display: block;\n  padding: 0.375rem 0.75rem;\n  color: var(--text-dark);\n  text-decoration: none;\n  border-radius: 4px;\n  transition: all 0.2s;\n  font-size: 0.875rem;\n}\n\n.sidebar-link:hover {\n  background-color: var(--bg-light);\n  color: var(--primary-color);\n  transform: translateX(2px);\n}\n\n.sidebar-link.active {\n  background-color: var(--primary-color);\n  color: white;\n}\n\n/* Content Area */\n.docs-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.docs-article {\n  max-width: 800px;\n  margin-bottom: 3rem;\n}\n\n/* Typography */\n.docs-article h1 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  color: var(--text-dark);\n  line-height: 1.2;\n}\n\n.docs-article h2 {\n  font-size: 1.875rem;\n  font-weight: 600;\n  margin: 2.5rem 0 1rem;\n  color: var(--text-dark);\n  border-bottom: 2px solid var(--border-color);\n  padding-bottom: 0.5rem;\n}\n\n.docs-article h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 2rem 0 1rem;\n  color: var(--text-dark);\n}\n\n.docs-article h4 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 1.5rem 0 0.75rem;\n  color: var(--text-dark);\n}\n\n.docs-article p {\n  margin-bottom: 1rem;\n  color: var(--text-dark);\n  line-height: 1.7;\n}\n\n.docs-article ul,\n.docs-article ol {\n  margin-bottom: 1rem;\n  padding-left: 2rem;\n}\n\n.docs-article li {\n  margin-bottom: 0.5rem;\n  color: var(--text-dark);\n}\n\n/* Code Blocks */\n.docs-article code {\n  background: var(--bg-light);\n  padding: 0.2rem 0.4rem;\n  border-radius: 3px;\n  font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;\n  font-size: 0.875em;\n  color: var(--primary-color);\n}\n\n.docs-article pre {\n  background: var(--bg-dark);\n  color: #e2e8f0;\n  padding: 1.5rem;\n  border-radius: 8px;\n  overflow-x: auto;\n  margin: 1.5rem 0;\n  font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.docs-article pre code {\n  background: none;\n  padding: 0;\n  color: inherit;\n  font-size: inherit;\n}\n\n/* Blockquotes */\n.docs-article blockquote {\n  border-left: 4px solid var(--primary-color);\n  padding-left: 1.5rem;\n  margin: 1.5rem 0;\n  font-style: italic;\n  color: var(--text-light);\n}\n\n/* Tables */\n.docs-article table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 1.5rem 0;\n  font-size: 0.875rem;\n}\n\n.docs-article th,\n.docs-article td {\n  padding: 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.docs-article th {\n  background: var(--bg-light);\n  font-weight: 600;\n  color: var(--text-dark);\n}\n\n.docs-article tr:hover {\n  background: var(--bg-light);\n}\n\n/* Links */\n.docs-article a {\n  color: var(--primary-color);\n  text-decoration: none;\n  border-bottom: 1px solid transparent;\n  transition: border-color 0.2s;\n}\n\n.docs-article a:hover {\n  border-bottom-color: var(--primary-color);\n}\n\n/* Page Footer */\n.docs-page-footer {\n  padding-top: 2rem;\n  border-top: 1px solid var(--border-color);\n}\n\n.docs-footer-nav {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n}\n\n.docs-contribute {\n  text-align: center;\n  padding: 1rem;\n  background: var(--bg-light);\n  border-radius: 6px;\n}\n\n.edit-link {\n  color: var(--primary-color);\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.edit-link:hover {\n  text-decoration: underline;\n}\n\n/* Site Footer */\n.docs-footer {\n  background: var(--bg-dark);\n  color: white;\n  padding: 3rem 0 1.5rem;\n  margin-top: 3rem;\n}\n\n.docs-footer-content {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.footer-section h4 {\n  margin-bottom: 1rem;\n  color: white;\n}\n\n.footer-section p {\n  color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 1rem;\n}\n\n.footer-links {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.footer-links a {\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.footer-links a:hover {\n  color: var(--primary-color);\n}\n\n.docs-footer-bottom {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  padding-top: 1.5rem;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .docs-content-wrapper {\n    flex-direction: column;\n  }\n\n  .docs-sidebar {\n    width: 100%;\n    position: static;\n    max-height: none;\n    margin-bottom: 2rem;\n  }\n\n  .search-input {\n    width: 200px;\n  }\n}\n\n@media (max-width: 768px) {\n  .docs-header-content {\n    flex-direction: column;\n    height: auto;\n    padding: 1rem 0;\n    gap: 1rem;\n  }\n\n  .docs-nav {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 1rem;\n  }\n\n  .search-input {\n    width: 100%;\n  }\n\n  .docs-article h1 {\n    font-size: 2rem;\n  }\n\n  .docs-article h2 {\n    font-size: 1.5rem;\n  }\n\n  .docs-footer-content {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .docs-header,\n  .docs-sidebar,\n  .docs-page-footer,\n  .docs-footer {\n    display: none;\n  }\n\n  .docs-content {\n    max-width: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  .docs-article a {\n    color: inherit;\n    text-decoration: underline;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
